<template>
<v-container fluid class="main--text mb-12">
    <h1 class="page-title text-center">Dash Waste FAQs</h1>
    <faqs/>
</v-container>
    
</template>

<script>

import faqs from '@/components/faqs.vue'
export default {
    name: 'help',
    components: { faqs},
    mounted(){
    scrollTo(0, 0);
  }
}
</script>

<style scoped>
.page-title{
  font-family: Avenir1;
  font-size: 48px;
  line-height: 64px;
  margin-top: 48px;
}
</style>
